import { set } from '@/utils/vuex'

export default {
  // Timers
  setCurrentTimestamp: set('currentTimestamp'),
  setFetchedTimestamp: set('fetchedTimestamp'),
  setIntervalId: set('intervalId'),

  // Data
  setGroup: set('group'),
  setMaxLevel: set('maxLevel'),
  setExpandedIds: set('expandedIds'),
  toggleExpandedIds ({ expandedIds }, id) {
    const index = expandedIds.indexOf(id)
    if (index === -1) expandedIds.push(id)
    else expandedIds.splice(index, 1)
  }
}
